import React, { useContext } from "react";
import { Grid, Paper, Typography, Hidden } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import background from "../../../images/graphic-icon/backgroundimage.png";
import Servicetype from "./Servicetype";
import StartNow from "./startNow";
import { LangContext } from "../../../Context/Langcontext";
const useStyle = makeStyles((theme) => ({
  root: { height: "100%", width: "100%" },
  bgimage: {
    height: "auto",
    width: "100%",
    marginTop: "6rem",
  },
  paper: {
    width: "100%",
    height: "100%",
    overflowY: "auto",
    boxShadow: "unset",
  },
  itemcenter: {
    display: "flex",
    width: "100%",
    height: "100%",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
  },
  maintext: {
    fontWeight: 700,
    fontSize: "4rem",
    color: "#FFFFFF",
    letterSpacing: 4,
  },
  secondtext: {
    fontSize: "1.2rem",
    fontWeight: 200,
    textAlign: "center",
    color: "#BFC0BF",
    maxWidth: 860,
  },
  itemmain: {
    display: "flex",
    width: "100%",
    justifyContent: "center",
    paddingTop: "1rem",
  },
  itemtext: {
    height: "100%",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
  },
  appbar: {
    position: "static",
    width: "100%",
    height: "5rem",
  },
}));

const Service = (props) => {
  const classes = useStyle();
  const langContext = useContext(LangContext);
  const lang = langContext.lang.data;

  return (
    <div>
      <div className={classes.appbar} />
      <Grid container spacing={0} className={classes.root}>
        <Grid
          item
          xs={12}
          style={{
            height: "100%",
          }}
        >
          <Paper className={classes.paper}>
            <Grid container spacing={0} className={classes.root}>
              <Grid item xs={12}>
                <div className={classes.itemcenter}>
                  <div
                    style={{
                      height: "auto",
                      width: "100%",
                      position: "absolute",
                    }}
                  >
                    <div className={classes.itemtext}>
                      <div data-aos="fade-up" data-aos-duration="2000">
                        <Typography className={classes.maintext}>
                          {lang.SERVICE.toUpperCase()}
                        </Typography>
                        <Hidden smDown mdDown>
                          <div className={classes.itemmain}>
                            <Typography className={classes.secondtext}>
                              {lang.SubtitlesService}
                              {/* Usu habeo equidem sanctus no. Suas summo id sed,
                              erat erant oporteat cu pri. In eum omnes molestie.
                              Sed ad debet scaevola, ne mel.555 */}
                            </Typography>
                          </div>
                        </Hidden>
                      </div>
                    </div>
                  </div>

                  <img
                    alt="bgimage"
                    src={background}
                    style={{
                      width: "100%",
                      height: "auto",
                    }}
                  />
                </div>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </Grid>
      <Servicetype />
      <StartNow />
    </div>
  );
};

export default Service;
